/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';

/**
 * 
 * @export
 * @interface RefreshInvoiceUrlResponse
 */
export interface RefreshInvoiceUrlResponse {
    /**
     * 
     * @type {Invoice}
     * @memberof RefreshInvoiceUrlResponse
     */
    data: Invoice;
}

/**
 * Check if a given object implements the RefreshInvoiceUrlResponse interface.
 */
export function instanceOfRefreshInvoiceUrlResponse(value: object): value is RefreshInvoiceUrlResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RefreshInvoiceUrlResponseFromJSON(json: any): RefreshInvoiceUrlResponse {
    return RefreshInvoiceUrlResponseFromJSONTyped(json, false);
}

export function RefreshInvoiceUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshInvoiceUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': InvoiceFromJSON(json['data']),
    };
}

  export function RefreshInvoiceUrlResponseToJSON(json: any): RefreshInvoiceUrlResponse {
      return RefreshInvoiceUrlResponseToJSONTyped(json, false);
  }

  export function RefreshInvoiceUrlResponseToJSONTyped(value?: RefreshInvoiceUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InvoiceToJSON(value['data']),
    };
}

